export default __webpack_public_path__ + "static/media/SGV-2020.93737212.png";